import React from 'react';

import { outlinedButtonClasses } from '../Button';

export interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  title?: string;
  subtitle?: string;
}

const RectangleButton = (props: Props): JSX.Element => {
  const { className, onClick, subtitle, title, ...rest } = props;

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>): void => {
    if (onClick) {
      onClick(e);
    }
  };

  return (
    // order matters for the classes
    <button
      type='button'
      className={'transition-all border-2 border-sapphire-50 bg-white cursor-pointer duration-500 rounded-xl h-20 w-full '
        + `${outlinedButtonClasses}${className ? ` ${className}` : ''}`}
      onClick={handleClick}
      aria-label={title}
      {...rest}
    >
      {title && title?.length > 0 && (
        <div className='font-medium text-lg self-center pb-1'>
          {title}
        </div>
      )}
      {subtitle && subtitle?.length > 0 && (
        <div className='text-center font-medium text-xs'>
          {subtitle}
        </div>
      )}
    </button>
  );
};

export { RectangleButton };
